import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScFeaturesSection = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;

  @media (${device.mobile}) {
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: repeat(3, 1fr);
    margin: 0 auto;
  }
`;
